import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Card from 'components/Card';
import Panel from 'components/Panel';
import EmptyStateController from 'components/EmptyStateController';
import useUniqueId from 'hooks/useUniqueId';
import { useFetchMyCalendarSettings } from './hooks/useFetchMyCalendarSettings';
import CalendarDisconnectedContent from './CalendarDisconnectedContent';
import CalendarLinkedContent from './CalendarLinkedContent';
import CalendarDeAuthorisedContent from './CalendarDeAuthorisedContent';
function UserCalendarIntegration() {
  var _data$hasAccountLinke, _data$hasActiveSubscr;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data,
    isLoading = _useFetchMyCalendarSe.isLoading,
    isError = _useFetchMyCalendarSe.isError;
  var hasAccountLinked = (_data$hasAccountLinke = data === null || data === void 0 ? void 0 : data.hasAccountLinked) !== null && _data$hasAccountLinke !== void 0 ? _data$hasAccountLinke : false;
  var hasActiveSubscription = (_data$hasActiveSubscr = data === null || data === void 0 ? void 0 : data.hasActiveSubscription) !== null && _data$hasActiveSubscr !== void 0 ? _data$hasActiveSubscr : false;
  return /*#__PURE__*/React.createElement(Card, {
    role: "region",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: "s",
    id: titleId
  }, t('auto_join_settings_title')), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    isEmpty: !data,
    data: data
  }, !hasAccountLinked && /*#__PURE__*/React.createElement(CalendarDisconnectedContent, null), hasAccountLinked && hasActiveSubscription && data && /*#__PURE__*/React.createElement(CalendarLinkedContent, {
    settings: data
  }), hasAccountLinked && !hasActiveSubscription && data && /*#__PURE__*/React.createElement(CalendarDeAuthorisedContent, {
    settings: data
  }))));
}
export default UserCalendarIntegration;